import { Injectable } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';

@Injectable({
  providedIn: 'root'
})
export class LoadingModalService {
  private modalRef: NgbModalRef;

  constructor(private modalService: NgbModal) {}

  open(content: any) {
    this.modalRef = this.modalService.open(content, { backdrop: 'static', keyboard: false,  });
  }

  close() {
    if (this.modalRef) {
      this.modalRef.close();
    }
  }
}